<template lang="html">
  <div class="card" :style="selfStyle">
    <div class="card-body">
      <fieldset class="card-header">
        <legend>回贴</legend>
      </fieldset>
      <div class="reply-box">
        <div class="reply-item" :key="item.pk" v-for="(item, index) in datas">
          <div class="reply-item-info">
            <img v-lazy="item.user__avatar" alt="">
            <div class="card-info-details">
              <div class="card-info-details-top">
                <div class="">
                  <span class="name">{{item.user__nickName}}</span>
                  <!-- <span class="vip">{{item.role}}</span> -->
                  <span name="time">{{item.createTime}}</span>
                </div>
                <span>第{{index + 1}}楼</span>
              </div>
            </div>
          </div>
          <div class="readonly-rich" v-html="item.content"></div>
          <div class="reply-item-reply">
            <span class="icon iconfont">&#xe635;</span>
            <span @click="parentReply(item.user__nickName, item.pk)">回复</span>
          </div>
        </div>
      </div>
    </div>

    <div class="rich" id="rich"></div>
    <button type="button" class="button" @click="submit">立即发布</button>
  </div>
</template>

<script>
import E from 'wangeditor'
import { get, post } from '../../../utils/request'
import { HOST } from '../../../utils/config'
import { get as getUser } from '../../../utils/token'
let editor = null
export default {
  props: [
    'selfStyle'
  ],
  components: {
  },
  mounted () {
    this.getReplyList()
    editor = new E('#rich')
    // editor.customConfig.uploadImgShowBase64 = true
    editor.customConfig.menus = [
      'head',
      'bold',
      'link',
      'quote',
      'image',
      'table',
      'emoticon'
    ]
    editor.customConfig.uploadImgParams = {
      name: 'test'
    }
    editor.customConfig.uploadFileName = 'file'
    editor.customConfig.uploadImgServer = `${HOST}/bbs/uploadFile`
    editor.create()
  },
  data () {
    return {
      datas: [],
      pid: 0,
      rich: ''
    }
  },
  methods: {
    parentReply (name, pk) {
      this.rich = name
      this.pid = pk
      editor.txt.html(`<p>@${name}:</p>`)
    },
    getReplyList () {
      const promise = get({
        url: `/bbs/commentTree/${this.$route.params.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
          this.datas = detail
          editor.txt.html('')
        }
      })
    },
    submit () {
      const params = {
        articleId: this.$route.params.id,
        content: editor.txt.html(),
        userId: getUser('user').id
      }
      if (this.pid) {
        params.pid = this.pid
      }
      const promise = post({
        url: '/bbs/comment',
        data: params
      })
      promise.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.getReplyList()
          this.pid = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/font/iconfont.css';
.label {
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  margin-right: 10px;
  font-size: 12px;
  border: 1px solid #FF5722;
  background: none;
  color: #FF5722;
}
.card {
  box-sizing: border-box;
  background: transparent;
  padding: 0 7.5px;
  margin-bottom: 15px;
  width: 100%;
  border-radius: 2px;
  .card-body {
    padding: 20px;
    background-color: #fff;
    .card-header {
      border: none;
      border-top: 1px solid #e6e6e6;
      margin-bottom: 20px;
      legend {
        margin-left: 20px;
        padding: 0 10px;
        font-size: 20px;
        font-weight: 300;
      }
    }
    .reply-box {
      margin-bottom: 30px;
      .reply-item {
        line-height: 20px;
        padding: 15px 15px 15px 15px;
        font-size: 13px;
        color: #999;
        border-bottom: 1px dotted #DFDFDF;
        .readonly-rich {
          margin: 25px 0 20px;
          min-height: 0;
          line-height: 24px;
          font-size: 14px;
        }
        .reply-item-info {
          display: flex;
          img {
            width: 48px;
            height: 48px;
            margin-right: 15px;
          }
          .card-info-details {
            width: 100%;
            display: inline-block;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            .card-info-details-top {
              display: flex;
              justify-content: space-between;
              align-items: center;
              span {
                display: inline-block;
                margin-right: 10px;
              }
              .name {
                color: #01AAED;
              }
              .vip {
                height: 16px;
                line-height: 16px;
                padding: 0 3px;
                background-color: #FF5722;
                color: #fff;
                border-radius: 2px;
              }
              .time {
                line-height: 20px;
                padding: 15px 15px 15px 75px;
                font-size: 13px;
                background-color: #f8f8f8;
                color: #999;
              }
            }
          }
        }
        .reply-item-reply {
          font-size: 16px;
          color: #999;
          .iconfont {
            margin-right: 5px;
          }
        }
        .readonly-rich {
          margin: 25px 0 20px;
          min-height: 0;
          line-height: 24px;
          font-size: 14px;
        }
      }
    }
  }
  .rich {
    padding: 0 20px;
  }
  .button {
    margin-left: 20px;
    display: inline-block;
    height: 38px;
    line-height: 38px;
    padding: 0 18px;
    background-color: #009688;
    color: #fff;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    color: #fff;
    margin-top: 20px;
  }
}
</style>
